export const QA_NAME_NEXT_BTN = 'next'

export const QA_NAME_PREV_BTN = 'prev'
